var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.propDialogObject.item
        ? _c(
            "el-dialog",
            {
              staticClass: "d-start-new-train-dialog",
              attrs: {
                title: "开启新培训",
                visible: _vm.dialogVisible,
                width: "600px",
                "before-close": _vm.closeDialog
              },
              on: {
                "update:visible": function($event) {
                  _vm.dialogVisible = $event
                }
              }
            },
            [
              _c("div", { staticClass: "c-text-tips" }, [
                _vm._v(" " + _vm._s(_vm.propDialogObject.item.message) + " ")
              ]),
              _c(
                "div",
                { staticClass: "c-form-wrapper" },
                [
                  _c("div", { staticClass: "c-form-header" }, [
                    _c("img", {
                      staticClass: "icon-image",
                      attrs: { src: _vm.iconImage }
                    }),
                    _c("p", { staticClass: "c-text-desc" }, [
                      _vm._v(
                        " 若选择”开启新培训“将强制签退【" +
                          _vm._s(
                            _vm.propDialogObject.item
                              ? _vm.propDialogObject.item.planName
                              : ""
                          ) +
                          "】中的"
                      ),
                      _vm.propDialogObject.item.studentCount > 0
                        ? _c("span", { staticClass: "c-text-number-red" }, [
                            _vm._v(
                              _vm._s(_vm.propDialogObject.item.studentCount)
                            )
                          ])
                        : _vm._e(),
                      _vm.propDialogObject.item.studentCount > 0
                        ? _c("span", { staticClass: "c-text-desc-red" }, [
                            _vm._v("个学员")
                          ])
                        : _vm._e(),
                      _vm.propDialogObject.item.studentCount > 0 &&
                      _vm.propDialogObject.item.supervisorCount > 0
                        ? _c("span", { staticClass: "c-text-desc-red" }, [
                            _vm._v("和")
                          ])
                        : _vm._e(),
                      _vm.propDialogObject.item.supervisorCount > 0
                        ? _c("span", { staticClass: "c-text-number-red" }, [
                            _vm._v(
                              _vm._s(_vm.propDialogObject.item.supervisorCount)
                            )
                          ])
                        : _vm._e(),
                      _vm.propDialogObject.item.supervisorCount > 0
                        ? _c("span", { staticClass: "c-text-desc-red" }, [
                            _vm._v("个监督人")
                          ])
                        : _vm._e(),
                      _vm.propDialogObject.item.supervisorCount > 0 ||
                      _vm.propDialogObject.item.studentCount > 0
                        ? _c("span")
                        : _vm._e(),
                      _c("span", { staticClass: "c-text-desc-red" }, [
                        _vm._v("，")
                      ]),
                      _vm._v("导致学员学时无效，请谨慎操作！ ")
                    ])
                  ]),
                  _c(
                    "el-form",
                    {
                      ref: "ruleForm",
                      staticClass: "demo-ruleForm",
                      attrs: {
                        model: _vm.ruleForm,
                        rules: _vm.rules,
                        "label-width": "70px"
                      },
                      nativeOn: {
                        submit: function($event) {
                          $event.preventDefault()
                        }
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "密码", prop: "passWord" } },
                        [
                          _c("el-input", {
                            attrs: {
                              size: "medium",
                              type: "password",
                              placeholder: "请输入密码",
                              autocomplete: "off"
                            },
                            on: { input: _vm.changePwd },
                            model: {
                              value: _vm.ruleForm.passWord,
                              callback: function($$v) {
                                _vm.$set(_vm.ruleForm, "passWord", $$v)
                              },
                              expression: "ruleForm.passWord"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "medium" },
                      on: {
                        click: function($event) {
                          return _vm.onTrainEvent(1)
                        }
                      }
                    },
                    [_vm._v("开启新培训")]
                  ),
                  _vm.propDialogObject.item.isShowReplaceClassroom
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "medium" },
                          on: { click: _vm.closeDialog }
                        },
                        [_vm._v("更换")]
                      )
                    : _vm._e(),
                  _vm.propDialogObject.item.isShowReplaceStudent
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "medium" },
                          on: { click: _vm.closeDialog }
                        },
                        [_vm._v("更换人员")]
                      )
                    : _vm._e(),
                  _vm.propDialogObject.item.isShowContinueStudy
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "medium" },
                          on: {
                            click: function($event) {
                              return _vm.onTrainEvent(2)
                            }
                          }
                        },
                        [_vm._v("继续培训")]
                      )
                    : _vm._e(),
                  _vm.showCancelButton
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "medium" },
                          on: { click: _vm.closeDialog }
                        },
                        [_vm._v("放弃")]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _c("LoginForceOutSureDialog", {
        attrs: {
          propDialogVisible: _vm.loginForceOutDialog.visible,
          propDialogObject: _vm.propDialogObject
        },
        on: {
          "update:propDialogVisible": function($event) {
            return _vm.$set(_vm.loginForceOutDialog, "visible", $event)
          },
          "update:prop-dialog-visible": function($event) {
            return _vm.$set(_vm.loginForceOutDialog, "visible", $event)
          },
          "call-back": _vm.callForceOutSureDialogBack
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }